import resourceService from './resource_service';

const modelName = 'dashboard';

const attributes = {
  name: '',
  appUsage: [],
  appHistory: [],
};

const relationships = {};

export default resourceService(modelName, attributes, relationships);
